import { Injectable } from '@angular/core'
import { MsalService } from '@azure/msal-angular'
import { ConfigService } from '../config/config.service'
import { UserService } from '../user-service/user-service.service'

@Injectable({
  providedIn: 'root',
})
export class AuthUtilsService {
  constructor(
    private config: ConfigService,
    private authService: MsalService,
    private userService: UserService,
  ) {}

  public logout() {
    // Clear session-derived state first so that, once the browser navigates
    // back from Microsoft's logout redirect, a fresh page load doesn't read a
    // stale "logged in" flag and render authenticated UI (e.g. the sidebar)
    // before MSAL's own account cache has caught up with the logout.
    // Wrapped so a storage failure doesn't stop logoutRedirect() from firing below.
    try {
      this.userService.ClearSession()
      // Record that this was an active, user-initiated logout so the next
      // login attempt forces the Entra account picker rather than silently
      // re-authenticating with the same account via SSO
      this.userService.SetExplicitLogout()
    } catch (error) {
      console.error('Failed to clear session state before logout', error)
    }

    //Remove trailing  / in baseUri
    let baseUri = this.config.getSettings('spa').baseUri
    if (this.config.getSettings('spa').baseUri.endsWith('/')) {
      baseUri = this.config
        .getSettings('spa')
        .baseUri.substring(0, this.config.getSettings('spa').baseUri.length - 1)
    }
    this.authService.logoutRedirect({
      account: this.authService.instance.getActiveAccount(),
      postLogoutRedirectUri:
        baseUri + this.config.getSettings('msal').auth.postLogoutRedirectUri,
    })
  }
}
